import "../../styles/menu.scss";
import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import { MenuSelectors, SearchSelectors } from "../../redux/selectors/index.js";
import { useSelector } from "react-redux";
import Logo from "../Logo.js";
import classNames from "classnames";
import IslandResort from "../../segmentedComponents/Header/IslandResort.js";
import { FormattedMessage } from "react-intl";
import { LocalizationMessages } from "../../localization/messages.js";
import { useDispatch } from "react-redux";
import {
  MenuActionCreators,
  SearchActionCreators
} from "../../redux/action-creators/index.js";
import { DrawerType } from "../../constants/index.js";
import { SVGIcon2 } from "../common/SVGIconV2.js";

const ActionDelay = { Regular: 300, Search: 0 };

const useBackButtonActivation = () => {
  const searchActive = useSelector(SearchSelectors.searchActive);
  const oddsMenuVisible = useSelector(MenuSelectors.oddsMenuVisible);
  const languageMenuVisible = useSelector(MenuSelectors.languageMenuVisible);
  const quickLinksInnerMenuVisible = useSelector(
    MenuSelectors.quickLinksInnerMenuVisible
  );
  const appearanceMenuVisible = useSelector(
    MenuSelectors.appearanceMenuVisible
  );

  const [backActivated, setBackActivated] = useState(false);

  useEffect(() => {
    const backActivated =
      oddsMenuVisible ||
      languageMenuVisible ||
      quickLinksInnerMenuVisible ||
      appearanceMenuVisible ||
      searchActive;

    if (!backActivated) setBackActivated(false);
    else {
      const actionDelay = searchActive
        ? ActionDelay.Search
        : ActionDelay.Regular;
      setTimeout(() => {
        setBackActivated(backActivated);
      }, actionDelay);
    }
  }, [
    appearanceMenuVisible,
    languageMenuVisible,
    oddsMenuVisible,
    quickLinksInnerMenuVisible,
    searchActive
  ]);

  return backActivated;
};

const MobileDrawerHeader = ({ menu }) => {
  const dispatch = useDispatch();
  const searchActive = useSelector(SearchSelectors.searchActive);

  const hasFavoriteSport = useMemo(
    () => menu === DrawerType.HamburgerMenu,
    [menu]
  );

  const backActivated = useBackButtonActivation();

  const closeMenus = () => {
    if (searchActive) {
      dispatch(SearchActionCreators.setTerm(""));
      dispatch(SearchActionCreators.toggleSearchDrawer(false));
    }
    if (hasFavoriteSport) {
      dispatch(
        MenuActionCreators.setFavouriteSportsRunningInsideInnerMenu(false)
      );
    }
    dispatch(MenuActionCreators[`hide${menu}`]());
  };

  const handleMenuCloseBtn = () => {
    if (searchActive) {
      dispatch(SearchActionCreators.toggleSearchDrawer(false));
    } else {
      dispatch(MenuActionCreators[`hide${menu}`]());
      if (menu !== "HamburgerMenu") {
        dispatch(MenuActionCreators.showHamburgerMenu());
      }
    }
  };

  return (
    <div className="top-section-wrapper">
      <Logo onClick={closeMenus} id="logo" />
      <IslandResort />
      <div
        className={classNames("menu-close-btn", { backActivated })}
        onClick={handleMenuCloseBtn}
      >
        <SVGIcon2
          iconName={backActivated ? "cool_arrow" : "close"}
          id="closeMenuBtn"
          className={classNames("close-btn-icon")}
        />
        {searchActive && backActivated && (
          <span className="backBtnTxt">
            <FormattedMessage {...LocalizationMessages.searchResultsBack} />
          </span>
        )}
      </div>
    </div>
  );
};

MobileDrawerHeader.propTypes = {
  menu: PropTypes.string
};

export default React.memo(MobileDrawerHeader);
